export default __webpack_public_path__ + "static/media/plus.aa46f0cc.svg";